import { computed, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useDistributeFeedStore } from '@/stores/distributeFeed'
import { useUserStore } from '@/stores/user'
import { syncUserFromCookie } from '@/composables/useInitUser'
export function useDistributeFeed() {
  const store = useDistributeFeedStore()
  const state = storeToRefs(store)
  const userStore = useUserStore()
  syncUserFromCookie(userStore)
  const { token } = storeToRefs(userStore)
  const isLoggedIn = computed(() => Boolean(token.value))

  if (!store.initialized && !store.loading) {
    void store.fetchNext()
  }

  watch(token, (nextToken, previousToken) => {
    if (nextToken === previousToken) {
      return
    }

    void store.refresh()
  })

  const isEmpty = computed(
    () => state.initialized.value && state.items.value.length === 0 && !state.loading.value,
  )

  return {
    ...state,
    isLoggedIn,
    isEmpty,
    fetchNext: () => store.fetchNext(),
    refresh: () => store.refresh(),
  }
}
